export const NAME = "Mike M.T Njovu";
export const OCCUPATION_LOACTION = "Senior Engineering Lead ";
export const IMG_URL =
  "https://lh3.googleusercontent.com/ogw/AF2bZyin_qkulL44ZjGofmy9cuGMFfCWeCZ-VvMjVdb6XkRhiHs=s32-c-mo";

export const ABOUT = [
  "Hi, I’m Mike Njovu, a passionate senior software engineer and technical leader with extensive experience in building scalable web and mobile applications.",
  "I specialize in modern JavaScript ecosystems, particularly React, TypeScript, and Laravel, crafting performant and maintainable codebases for fintech, SaaS, and e-commerce platforms.",
  "With a strong background in full-stack development, cloud infrastructure, and system design, I thrive on solving complex challenges, optimizing user experiences, and driving innovation through hands-on leadership and strategic vision.",
  "Beyond coding, I lead teams to deliver high-impact products, mentor engineers, and build developer-friendly tools.",
  "I’m also skilled in UI/UX design, bridging the gap between technical implementation and user-centered design.",
  "Currently, I’m focused on empowering startups and enterprises with cutting-edge tech solutions that scale efficiently and adapt to evolving market needs.",
];

// "Hi, I’m Mike Njovu, a passionate senior software engineer and technical leader with extensive experience in building scalable web and mobile applications. I specialize in modern JavaScript ecosystems, particularly React, TypeScript, and Laravel, crafting performant and maintainable codebases for fintech, SaaS, and e-commerce platforms. With a strong background in full-stack development, cloud infrastructure, and system design, I thrive on solving complex challenges, optimizing user experiences, and driving innovation through hands-on leadership and strategic vision. Beyond coding, I lead teams to deliver high-impact products, mentor engineers, and build developer-friendly tools. I’m also skilled in UI/UX design, bridging the gap between technical implementation and user-centered design. Currently, I’m focused on empowering startups and enterprises with cutting-edge tech solutions that scale efficiently and adapt to evolving market needs. I currently work as a Front-End Developer at ";
export const Company = {
  name: "Afrimeta Technologies",
  link: "https://www.afrimetatechnologies.com",
};
// export const HACKERGUILD = "Hackers Guild";

export const CONTACT = [
  // {
  //   id: 1,
  //   name: "Twitter",
  //   site: "https://twitter.com/MikeMNjovu1",
  //   color: "black",
  // },
  // {
  //   id: 2,
  //   name: "Facebook",
  //   site: "https://www.facebook.com/mike.manpower3",
  //   color: "green",
  // },
  {
    id: 3,
    name: "LinkedIn",
    site: "https://www.linkedin.com/in/mike-njovu-21ab23167?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BjQcjZC79QFSB7PM7EYbWdQ%3D%3D",
    color: "#96979c",
  },
  {
    id: 4,
    name: "Github",
    site: "https://github.com/mikemtdev",
    color: "green",
  },
  // {
  //   id: 5,
  //   name: "CodePen",
  //   site: "https://codepen.io/mikemnjovu",
  //   color: "#96979c",
  // },
  {
    id: 6,
    name: "Email",
    site: "mailto:mikemnjovu@gmail.com",
    color: "96979c",
  },
];
